import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Select from "react-select";
import { tiposEmailContratacaoEnum } from "../../../../utils/enums";
import { createSelectOptions, getByAtribute } from "../../../../utils/formatar";
import { Validacao } from "../../../comum/components/Validacao";
import { TooltipIcon } from "../../../comum/components/TooltipIcon";

@inject("store")
@observer
export class DetalhamentoPerfil extends Component {

    static propTypes = {
    };

    constructor(props) {
        super(props);
    }

    render() {
        const solicitacao = this.props.controller.solicitacao;

        //RHFPP-1020
        const tipoEmailContratacaoOptions = createSelectOptions(tiposEmailContratacaoEnum, "id", "valor");
        const tipoEmailContratacao = solicitacao.tipoEmailContratacao != null
            ? _.get(getByAtribute(tiposEmailContratacaoEnum, this.props.controller.solicitacao.tipoEmailContratacao, "id"), "valor", "")
            : "";
        const textoTipoEmailContratacao = solicitacao.tipoEmailContratacao != null
            ? _.get(getByAtribute(tiposEmailContratacaoEnum, this.props.controller.solicitacao.tipoEmailContratacao, "id"), "descricao", "")
            : "";

        const exibeSelectTipoEmailContratacao = this.props.controller.exibeSelectTipoEmailContratacao;    

        return (
            <div>
                <h4>Perfil</h4>
                <Row>
                    <Col xs={12} md={12}>
                        <FormGroup>
                            <Label>Detalhamento do perfil esperado</Label>
                            <Input type="textarea" value={_.get(solicitacao, "perfilRecurso")} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={6}>
                        <FormGroup>
                            {exibeSelectTipoEmailContratacao ? 
                                <div>
                                    <Label>
                                        Login/Equipamento Corporativo <sup>*</sup>
                                        <TooltipIcon textKey="solicitacaoContratacao.confirmarContratacao" />
                                    </Label>
                                    <Select value={this.props.controller.tipoEmailContratacao || ''}
                                        options={tipoEmailContratacaoOptions}
                                        onChange={(value) => this.props.controller.setTipoEmailContratacao(value)}
                                        placeholder="Selecione..."
                                        multi={false}/>
                                    <Validacao id="tipoEmailContratacao"
                                        valor={this.props.controller.tipoEmailContratacao}
                                        tipo={["isRequired"]}/>
                                </div>
                             : 
                                 <div>
                                    <Label>
                                        Login/Equipamento Corporativo
                                    </Label>
                                    <Input type="text" value={tipoEmailContratacao} readOnly />
                                </div>
                            }
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={12}>
                        <FormGroup>
                            <Label>Detalhamento</Label>
                            <Input type="textarea" value={textoTipoEmailContratacao} readOnly/>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}